/*global site_info */

export default {

    init() {
        this.cookieName = 'skybox_landing_page';
        this.banner = '.return-to-collection-bar';
        this.setup();
        this.showBanner();
    },

    setCookie(name, value, days) {
        let expires = '';
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    },
    getCookie(name) {
        let nameEQ = name + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return '{}';
    },
    eraseCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    showBanner() {
        let bannerCookie = JSON.parse(this.getCookie(this.cookieName));
        if (bannerCookie.type !== 'collection' || window.location.href === bannerCookie.url || !bannerCookie.show_banner) return;
        $('.return-to-collection-link').attr('href', bannerCookie.url);
        $('.return-to-collection-link .cookie-title').text(bannerCookie.title);
        $(this.banner).addClass('show');
    },

    setup() {
        if (this.getCookie(this.cookieName)) return;
        this.setCookie(this.cookieName, JSON.stringify(site_info.post_info), 1);
    },
};
